<template>
  <div class="query">
    <progress-bar :questionArray="presentationQuestionArray"
      :currentQuestionIndex="currentQuestionIndex"></progress-bar>
    <p class="query-title">{{ currentTitle }}</p>
    <question-view :model="currentQuestion" :initialResultValue="currentResultValue"
      :initialResultStringValue="currentResultStringValue" @onAnsweredCount="onAnsweredCount" @onAnswered="onAnswered"
      @onAnsweredTime="onAnsweredTime" @onAnsweredHasChildQuestion="onAnsweredHasChildQuestion"
      :currentQuestionIndex="currentQuestionIndex"></question-view>
    <button-view :questionArray="presentationQuestionArray" :currentQuestionIndex="currentQuestionIndex"
      @onBackClick="onBackClick" @onLastClick="onLastClick" @onNextClick="onNextClick"
      @onSubmitClick="onSubmitClick"></button-view>
  </div>
</template>

<script>
import QuestionView from '@c/query/question-view.vue'
import ButtonView from '@c/query/button-view.vue'
import ProgressBar from '@c/query/progress-bar.vue'
import API from '@/api';
import { NavigationTool } from '@/utils/navigation-tool.js'

export default {
  components: {
    ProgressBar,
    QuestionView,
    ButtonView
  },

  data() {
    return {
      assessmentItem: {},
      currentQuestionIndex: 0,
      questionArray: [],
      answerModel: {},
      isLocked: false, // 防止重复点击
      style: 0,
    }
  },

  computed: {

    presentationQuestionArray() {
      if (this.assessmentItem.type === 24) {
        const question393 = this.questionArray.find(el => el.assessmentId === 393)
        const pL = this.questionArray.filter((item) => {
          return item.assessmentId !== 393
        })
        const question392 = pL.find(el => el.assessmentId === 392)
        if (question392) {
          question392.childQuestion = question393;
        }
        return pL
      } else {
        return this.questionArray
      }

    },
    configurationModel() {
      return this.$store.state.configurationModel
    },

    accountModel() {
      return this.$store.state.accountModel
    },

    loginModel() {
      return this.$store.getters['user/getUser']
    },

    answerDataArray() {
      return this.$store.state.answerDataArray
    },

    currentTitle() {
      return `第${this.currentQuestionIndex + 1}题（共${this.presentationQuestionArray.length
        }题）`
    },

    currentQuestion() {
      return this.presentationQuestionArray[this.currentQuestionIndex]
    },
    currentResultValue() {
      const value = this.answerModel[this.currentQuestion?.assessmentId];
      if (typeof value === "number") {
        return value
      }

    },
    currentResultStringValue() {
      const value = this.answerModel[this.currentQuestion?.assessmentId];
      if (typeof value === "string") {
        return value
      }
    }
  },

  created: function () {
    this.assessmentItem = this.$router.history.current.query.assessmentItem
    // 动态修改导航栏名称
    this.$route.meta.title = this.assessmentItem.title
    // 强制刷新
    this.$router.replace({
      query: {
        temp: Date.now() // 必有
      }
    })
    // 获取问卷
    this.getQuery()
  },

  methods: {
    // action
    onAnswered(result) {

      if (this.isLocked) {
        return
      }
      this.style = result.style;
      this.isLocked = true
      this.answerModel[result.questionID] = result.value
      // 自动下一题
      if (this.currentQuestionIndex < this.presentationQuestionArray.length - 1) {
        setTimeout(() => {
          this.onNextClick()
        }, 300)
      }
    },
    onAnsweredTime(result) {
      this.style = result.style;
      this.isLocked = true
      this.answerModel[result.questionID] = result.value
      console.log(result);

    },

    onAnsweredHasChildQuestion(result) {
      this.style = result.style;
      this.isLocked = true
      this.answerModel[result.questionID] = result.value
    },

    onAnsweredCount(result) {
      this.style = result.style
      this.isLocked = true
      this.answerModel[result.questionID] = result.value
    },
    onBackClick() {

      // 多问卷
      if (this.configurationModel.needShowQueryList) {
        // 返回列表
        this.$router.push({ name: 'QueryList' })
      }


      // 无需考虑单问卷情况。因为已在button-view的UI中限制过
    },

    onLastClick() {
      this.currentQuestionIndex -= 1
    },

    onNextClick() {
      console.log(this.answerModel, this.currentQuestion.assessmentId);
      
      if (this.answerModel[this.currentQuestion.assessmentId] == undefined || this.answerModel[this.currentQuestion.assessmentId] === '') {
        this.$toast('内容不能为空')
        return
      }
      if (this.style == 3) {
        if (this.answerModel[this.currentQuestion.assessmentId] != -2) {
          if (this.answerModel[this.currentQuestion.assessmentId] > 100 || this.answerModel[this.currentQuestion.assessmentId] < 0) {
            this.$toast('请输入0~100的数字')
            return
          }
        }

      }
      if (this.style == 5) {
        if (this.answerModel[this.currentQuestion.assessmentId] > 720) {
          this.$toast('请输入0~720的数字')
          return
        }
      }
      if (this.currentQuestion.childQuestion) {
        if (this.currentQuestion.assessmentId === 392 && this.answerModel[this.currentQuestion.assessmentId] !== 0 && !this.answerModel[this.currentQuestion.childQuestion.assessmentId]) {
          this.$toast('内容不能为空')
          return
        }
      }
      this.currentQuestionIndex += 1
      this.isLocked = false
    },

    onSubmitClick() {
      if (this.answerModel[this.currentQuestion.assessmentId] == undefined) {
        this.$toast('内容不能为空')
        return
      }
      this.submit()
    },

    // method
    async getQuery() {

      const [error, data] = await to(this.getQueryRequest())
      if (error) {
        return
      }
      this.questionArray = data.assessment
      // 如果已填，载入答案
      if (this.assessmentItem.isFilled == true) {
        const answerData = this.answerDataArray.filter((item) => {
          return item.type == this.assessmentItem.type
        })[0]
        this.answerModel = answerData.content
      }
    },

    async submit() {
      // 多问卷
      if (this.configurationModel.needShowQueryList) {
        // 返回列表
        this.$router.push({ name: 'QueryList' })
        // 更新回答数据
        const filledQueryType = this.assessmentItem.type
        this.updateConfigurationModel(filledQueryType) // configurationModel
        const answerDataModel = {
          type: this.assessmentItem.type,
          content: this.answerModel
        }
        this.updateAnswerDataArray(answerDataModel) // answerDataArray
        return
      }
      // 单问卷
      const [error, data] = await to(this.submitRequest())
      if (error) {
        this.$toast(error)
        return
      }
      const isFromQuery = true
      const resultIDArray = data.map((item) => {
        return item.resultId
      })
      const resultIds = resultIDArray.join(',')
      NavigationTool.navigateToResultList(isFromQuery, resultIds)
    },

    updateConfigurationModel(filledQueryType) {
      const newConfigurationModel = this.configurationModel
      newConfigurationModel.assessmentArray.forEach((item, index) => {
        if (item.type == filledQueryType) {
          newConfigurationModel.assessmentArray[index].isFilled = true
        }
      })
      this.$store.commit('saveConfigurationModel', newConfigurationModel)
    },

    updateAnswerDataArray(answerModel) {
      const newAnswerDataArray = this.answerDataArray
      let isNew = true
      newAnswerDataArray.forEach((item, index) => {
        if (item.type == answerModel.type) {
          newAnswerDataArray[index] = answerModel
          isNew = false
        }
      })
      if (isNew) {
        newAnswerDataArray.push(answerModel)
      }
      this.$store.commit('saveAnswerDataArray', newAnswerDataArray)
    },

    // request
    getQueryRequest() {
      const params = {
        type: this.assessmentItem.type
      }
      return API.getQuery(params)
    },

    submitRequest() {
      const content = [
        {
          type: this.assessmentItem.type,
          content: this.answerModel
        }
      ]

      let data = {
        content: JSON.stringify(content),
        hospitalId: this.configurationModel.model.hospitalId,
        taskId: this.configurationModel.model.id,
        userInfo: JSON.stringify(this.accountModel.userInfo),
      }

      if (this.loginModel) {
        data.uid = this.loginModel.uid;
      }

      return API.submitQuery(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";

.query {
  background-color: #f9f9f9;
  font-size: 14px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  &-title {
    color: #323233;
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    margin-top: 4px;
    margin-bottom: 15px;
  }
}
</style>
